export default function StructureData(){
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Restaurant",
        "name": "Fyki Fyki",
        "image": "https://fykifyki.gr/android-chrome-512x512.png",
        "@id": "https://fykifyki.gr",
        "url": "https://fykifyki.gr",
        "telephone": "+302299076333",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Leof G. Gregou 45",
          "addressLocality": "Porto Rafti",
          "addressRegion": "Attiki",
          "postalCode": "19003",
          "addressCountry": "Greece"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 37.89380190013011,   
          "longitude": 24.01208123068592
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday"
            ],
            "opens": "12:30",
            "closes": "00:15"
          }
        ],
        "servesCuisine": ["Greek"],
        "priceRange": "$$"
      };

      return(
        <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
        </script>
      );
}